/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import styles from './menu.scss'

import {
  userSelector,
  showMenuPanelSelector,
  activeMenuPanelSelector
} from 'src/selectors'
import { showMenuPanel, hideMenuPanel, updateMenuPanel } from 'src/actions/frontend'

import MenuBar from 'src/components/menu/MenuBar'
import ProfilePanel from './panels/ProfilePanel'
import ChatPanel from './panels/ChatPanel'
import LoginPanel from './panels/LoginPanel'

export class Menu extends React.Component {
    _clearMenuPanel = () => {
      this.props.toggleMenuPanel(false)
      this.props.changeMenuPanel(null)
    }
    _renderActivePanel = (panel) => {
      switch (panel) {
        case 'profile':
          return <ProfilePanel user={this.props.user} />
        case 'chat':
          return <ChatPanel />
        case 'login':
          return <LoginPanel />
        default:
          return null
      }
    }

    componentDidMount () {
      this._clearMenuPanel()
    }

    render () {
      const { user, isMenuPanelActive, toggleMenuPanel, activeMenuPanel, changeMenuPanel } = this.props

      const onMenuItemClick = (selectedPanel) => {
        if (selectedPanel === activeMenuPanel || selectedPanel === 'profile') {
          this._clearMenuPanel()
        } else {
          toggleMenuPanel(true)
          changeMenuPanel(selectedPanel)
        }
      }

      return (
        <div className={styles['container']}>
          <MenuBar user={user} onMenuItemClick={onMenuItemClick} />
          {isMenuPanelActive && this._renderActivePanel(activeMenuPanel)}
        </div>
      )
    }
}

Menu.propTypes = {
  user: PropTypes.object,
  isMenuPanelActive: PropTypes.bool,
  activeMenuPanel: PropTypes.string,
  toggleMenuPanel: PropTypes.func,
  changeMenuPanel: PropTypes.func
}

function mapStateToProps (state) {
  return {
    user: userSelector(state),
    isMenuPanelActive: showMenuPanelSelector(state),
    activeMenuPanel: activeMenuPanelSelector(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {
    toggleMenuPanel: (shouldDisplayMenuPanel) => {
      if (shouldDisplayMenuPanel) {
        dispatch(showMenuPanel())
      } else {
        dispatch(hideMenuPanel())
      }
    },
    changeMenuPanel: (panel) => {
      dispatch(updateMenuPanel(panel))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/menu/Menu.jsx